const translations = {
  en: {
    //---------------------------Navbar---------------------------------------
    'Witamy na stonie': 'Welcome to',
    'Archiwum': 'Archive',
    'Kategorie': 'Categories',
    'Aktualności': 'Home',
    'O Firmie': 'About',
    'Oferta': 'Offer',
    'Silniki LMB': 'Engines',
    'Projekt': 'Project',
    'Zapytania ofertowe': 'Requests for jobs',
    'Media o nas': 'Media',
    'Do pobrania': 'Downloads',
    'Kontakt': 'Contact',
    'Zmień język': 'Change language',

    //-----------------------------Home-----------------------------------------
    'Od 16.01.2020. Filipek Filipek-Motors Sp. z o.o. realizuje projekt:':
      'Since 16.01.2020 Filipek-Motors Sp. z o.o. has been implementing the project:',
    'więcej informacji w zakładce':
      'more information is available in the Project tab',
    //------------------------------About---------------------------------------
    'Kapitał zakładowy:': 'Cash:',
    'Spółka': ' ',
    'dr inż. Grzegorza Kłosowskiego': 'dr inż. Grzegorz Kłosowski',
    'została zawiązana w dniu 13.12.2018 r. jako spółka typu spin-off.':
      'was established on 13.12.2018 as a spin-off company.',
    'Większościowym udziałowcem (90%) jest':
      'The majority shareholder (90%) is',
    'adiunkt w Katedrze Podstaw Konstrukcji Maszyn i Mechatroniki, Wydziału Mechanicznego Politechniki Lubelskiej.':
      'PhD, assistant professor in the Department of Machine Construction and Mechatronics, Faculty of Mechanical Engineering, Lublin University of Technology.',
    'Drugim udziałowcem (10%) jest': 'The second shareholder (10%) is',
    'spółka celowa Politechniki Lubelskiej reprezentowana przez':
      ' a special purpose vehicle of the Lublin University of Technology represented by',
    'adiunkta w Katedrze Organizacji Przedsiębiorstwa, Wydziału Zarządzania':
      ' assistant professor in the Department of Enterprise Organization, Faculty of Management.',
    'Prezesem Zarządu spółki jest': 'CEO is',
    'posiadający duże doświadczenie w zarządzaniu firmami':
      'with great experience in managing companies.',
    'Siedziba spółki Filipek - Motors Sp. z o. o. znajduje się przy ul.Nadbystrzyckiej 38H, 20-618 Lublin.':
      'The office of Filipek - Motors Sp. z o. o. is located at 38H Nadbystrzycka Street, 20-618 Lublin.',

    //------------------------------Jobs-----------------------------------------
    'Zapytanie ofertowe 1':'Request for offer 1',
    'Zapytanie ofertowe 3':'Request for offer 3',
    'Zapytanie ofertowe 4':'Request for offer 4',
    'Aktualne:':'Active:',
    'Archiwalne:':'Archive:',
    //------------------------------Engines--------------------------------------
    'Zastosowania': 'Applications',
    'techniki kosmiczne': 'space technology',
    'drony, modelarstwo': 'drones, modeling',
    'sprzęt AGD': 'household appliances',
    'elektronarzędzia': 'electric tools',
    'rowery elektryczne': 'electric bikes',
    'elektrownie wiatrowe (prądnice)': 'wind turbines',
    'wentylatory': 'fans',
    'pojazdy elektryczne': 'electric vehicles',
    'Konstrukcja dr inż. Przemysława Filipka':
      'Designed by dr inż. Przemysław Filipek',
    'Silniki LMB to innowacyjne, bezrdzeniowe, bezszczotkowe silniki prądu stałego':
      'LMB motors are innovative, brushless DC motors.',
    'Konstrukcja oparta jest na zasadzie bezpośredniego oddziaływania przewodu z prądem na linię międzybiegunową (LMB) magnesu trwałego.':
      'The construction is based on the principle of direct current-carrying interaction of the cable with the interpolar line (LMB) of the permanent magnet.',
    'Silniki te nie posiadają stalowego rdzenia, dzięki czemu zyskują wiele zalet w stosunku do silników BLDC: mniejsza masa, brak sił zaczepowych, brak strat magnesowania rdzenia.':
      'These motors do not have a steel core, which gives them many advantages compared to BLDC motors: less weight, no striking forces, no loss of core magnetization.',
    'Do Urzędu Patentowego RP przesłano 23 zgłoszenia patentowe urządzeń działających na zasadzie LMB, z czego przyznano juz 7 patentów. Na pozostałe czekamy.':
      '23 patent applications for LMB devices have been sent to the Polish Patent Office, 7 of which have already been granted. We are waiting for the others.',
    'Prototypy silników LMB': 'LMB engine prototypes',
    'Silniki LMB nie powstały przez zwykłe usunięcie stalowego rdzenia z silnika BLDC':
      'LMB engines were not created by simply removing the steel core from the BLDC engine',
    'Opierają się na innej zasadzie pracy i innej konstrukcji niż silniki BLDC. W zasadzie jedyną ich cechą wspólną jest brak szczotek i zastosowanie elektronicznego komutatora z wykorzystaniem czujników hallotronowych.':
      'They rely on a different operating principle and design than BLDC engines. In principle, their only common feature is the absence of brushes and the use of an electronic commutator using hallotron sensors.',
    'Dotychczas budowane prototypy są jednofazowe, ale mogą być dwufazowe lub nawet trójfazowe. Prototypy wykonano z filamentu oraz żywicowych wydruków 3D. Konstrukcja LMB może działać zarówno jako silnik, jak i prądnica.':
      'The prototypes built so far are single-phase, but can be two-phase or even three-phase. The prototypes are made of filament and 3D resin prints. The LMB construction can act as a motor as well as a generator.',
    'Sterowniki - analogowy i mikroprocesorowy':
      'Controllers - analogue and microprocessor-based',
    'Elektroniczne sterowniki silników BLDC nie nadają się do sterowania silnikami LMB':
      'BLDC electronic motor controllers are not suitable for controlling LMB motors',
    'Silinki LMB posiadają własne sterowniki, które mogą być budowane jako analogowe lub mikroprocesorowe, kontrolując wiele parametrów pracy silnika - jak np. jego prędkość obrotową, moc, tryby pracy (stała prędkość obrotowa, stały moment).':
      'LMB engines have their own controllers, which can be built as analogue or microprocessor-based, controlling many parameters of engine operation - such as e.g. its rotational speed, power, modes of operation (constant rotational speed, constant torque).',

    //----------------------------Project---------------------------------------
    'Projekt dotyczy':'The project refers',
    'przeprowadzenia badań przemysłowych związanych z nowym typem silników prądu stałego, opartych na zjawisku oddziaływania przewodnika z prądem na linię międzybiegunową LMB magnesu trwałego, eksperymentalnych prac rozwojowych dla prądnic i silników prądu stałego LMB oraz prac przedwdrożeniowych związanych z przygotowaniem silników i prądnic LMB o ustalonym typoszeregu do produkcji.':'to industrial research related to a new type of DC motors, based on the phenomenon of interaction of conductor with current on the interpolar line of LMB permanent magnet, experimental development works for LMB DC generators and motors and pre-implementation works related to the preparation of LMB fixed type motors and generators for production',
    'Badania przemysłowe':'Industrial research',
    'pozwolą na określenie zasad dla zjawiska LMB potrzebnych do obliczeń parametrów konstrukcyjnych silników i prądnic LMB, zaprojektowania typoszeregu dla tych urządzeń oraz sporządzenia dokumentacji konstrukcyjnej. Zostaną wykonane modele silników i prądnic LMB oraz przeprowadzone ich badania.':'will allow to define rules for LMB phenomenon needed to calculate constructional parameters of LMB motors and generators, design series of types for these devices and prepare constructional documentation. Models of LMB motors and generators will be made and their tests will be carried out.',
    'Eksperymentalne prace rozwojowe':'Experimental development',
    'umożliwią budowę prototypów silników i prądnic LMB, wyznaczenie ich charakterystyk pracy, realizację elektronicznego sterownika i wykonanie testów w warunkach rzeczywistych.':'work will make it possible to build prototypes of LMB engines and generators, determine their operating characteristics, implement an electronic controller and perform tests under real conditions.',
    'Prace przedwdrożeniowe':'Pre-implementation work',
    'obejmą certyfikację i testowanie urządzeń LMB oraz przygotują grupę silników i prądnic LMB do produkcji seryjnej.':'will include certification and testing of LMB equipment and prepare a group of LMB motors and generators for serial production.',
    'Silniki LMB':'LMB engines',
    'mogą być wykorzystywane w transporcie (w pojazdach elektrycznych, modelarstwie (drony), łodziach, rowerach, wózkach inwalidzkich i transporcie wewnątrzzakładowym) oraz jako oddzielne silniki napędowe. Prądnice LMB mogą być stosowane w transporcie jako mini prądnice wiatrowe (energia odnawialna) i generatory energii elektrycznej (alternatory).':'can be used in transport (in electric vehicles, modelling (drones), boats, bicycles, wheelchairs and internal transport) and as separate drive motors. LMB generators can be used in transport as mini wind generators (renewable energy) and electricity generators (alternators).',
    'Nr projektu:':'Project number:',
    'Tytuł projektu:':'Project title:',
    'Zaprojektowanie i badania silników prądu stałego i prądnic LMB':'Design and testing of DC motors and LMB generators',
    'Okres realizacji:':'Implementation period:',
    'Projekt współfinansowany ze środków Europejskiego Funduszu Rozwoju Regionalnego w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020.':'The project is co-financed by the European Regional Development Fund under the Intelligent Development Operational Programme 2014-2020',
    'Całkowita wartość Projektu:':'Total project value:',
    'Dofinansowanie Projektu z Unii Europejskiej:':'Co-financed project value:',
    'Filipek-Motors Sp. z o.o. realizuje projekt:':'Filipek-Motors Sp. z o.o. is developing the project:',
    'Projekt nr: POIR.01.01.01-00-0245/19':'Project nr: POIR.01.01.01-00-0245/19',
    'współfinansowany ze środków Europejskiego Funduszu Rozwoju Regionalnego':'co-financed by the European Regional Development Fund',
    'w ramach ”Programu Operacyjnego Inteligentny Rozwój 2014 – 2020”.':'under the "Intelligent Development Operational Programme 2014 - 2020".',

    //------------------------------Offer---------------------------------------
    'Spółki': 'Companies',
    'Zakładanie spółek': 'Company formation',
    'Usługi': 'Services',
    'Usługi doradczo-konsultingowe': 'Advice and consulting services',
    'Działalność:': 'Activities',
    'Uruchamianie działalności gospodarczej': 'Starting up a business',
    "Zapytaj o szczegóły":"More info",

    //------------------------------Media---------------------------------------
    'Telewizja:': 'Television',
    'Prasa:': 'Newspaper',

    //------------------------------Contact-------------------------------------
    'Adres E-mail': 'E-mail address',
    'Chwilowo - brak': 'There is nothing here',

    //------------------------------Footer---------------------------------------
    'Firma': 'Company',
    'Nazwa:': 'Name:',
    'Prezes Zarządu:': 'CEO:',
    'Udziałowiec większościowy:': 'Majority owner:',
    'Udziałowiec mniejszościowy:': 'Minority owner:',
    'Lokalizacja': 'Location',
    'Adres siedziby:': 'Address:',
    'Miejsce realizacji projektu:':'Location of project realization:'
  },
};

export const translate = sentence => {
  const language = localStorage.getItem('lang');

  if (language === 'en') {
    return translations.en[sentence] || sentence;
  } else {
    return sentence;
  }
};
